import { useState, useEffect } from 'react';
import api from '../api';
import { useAuth } from '../context/AuthContext';
import { TimeSeriesChart, CameraCompareChart, PeakHoursChart } from '../components/Charts';
import toast from 'react-hot-toast';

export default function ClientDashboard() {
  const { user } = useAuth();
  const [stats, setStats] = useState(null);
  const [chartData, setChartData] = useState(null);
  const [cameras, setCameras] = useState([]);

  useEffect(() => {
    Promise.all([api.get('/reports/summary'), api.get('/reports/data?groupBy=day'), api.get('/cameras')])
      .then(([s, c, cams]) => { setStats(s.data); setChartData(c.data); setCameras(cams.data); })
      .catch(() => toast.error('Klaida kraunant duomenis'));
  }, []);

  return (
    <div>
      <div className="page-header">
        <div className="page-title">Sveiki, {user?.name}! 👋</div>
        <div className="page-subtitle">Axis Object Analytics srauto apžvalga</div>
      </div>

      {stats && (
        <div className="stats-grid">
          <S label="Šiandien žmonių"  value={stats.today.human}  sub="Axis: human"       color="#3b82f6" icon="🚶" />
          <S label="Šiandien aut."    value={stats.today.car}    sub="Axis: car"         color="#10b981" icon="🚗" />
          <S label="Savaitė (žmonės)" value={stats.week.human}   sub="7 dienų srautas"   color="#8b5cf6" icon="📅" />
          <S label="Mėnuo (žmonės)"   value={stats.month.human}  sub="30 dienų srautas"  color="#f59e0b" icon="📊" />
          <S label="Aktyvios kameros" value={stats.activeCameras} sub="prisijungtos"      color="#06b6d4" icon="📷" />
        </div>
      )}

      <div style={{ marginBottom: 24 }}>
        <div style={{ fontSize: 15, fontWeight: 700, marginBottom: 12 }}>📷 Mano Axis kameros</div>
        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(260px, 1fr))', gap: 12 }}>
          {cameras.map(cam => (
            <div key={cam.id} className="card card-sm" style={{ display: 'flex', gap: 12, alignItems: 'center' }}>
              <div className={`cam-dot ${cam.is_active ? 'online' : 'offline'}`} style={{ width: 12, height: 12, flexShrink: 0 }} />
              <div style={{ flex: 1 }}>
                <div style={{ fontWeight: 600, fontSize: 13 }}>{cam.name}</div>
                <div style={{ fontSize: 11, color: 'var(--text-muted)' }}>{cam.location || cam.ip_address}</div>
              </div>
              <div style={{ fontSize: 11, color: 'var(--text-muted)', textAlign: 'right' }}>
                {cam.last_poll ? new Date(cam.last_poll).toLocaleTimeString('lt-LT', {hour:'2-digit',minute:'2-digit'}) : '–'}
              </div>
            </div>
          ))}
        </div>
      </div>

      {chartData && <>
        <TimeSeriesChart data={chartData.timeSeries} title="📈 Srauto dinamika (30 d.)" type="area" />
        <div className="charts-grid">
          <CameraCompareChart data={chartData.perCamera} title="📷 Srautas pagal kamerą" />
          <PeakHoursChart data={chartData.timeSeries} title="⏰ Piko valandos" />
        </div>
      </>}
    </div>
  );
}

function S({ label, value, sub, color, icon }) {
  return (
    <div className="stat-card">
      <div className="stat-icon" style={{ color }}>{icon}</div>
      <div className="stat-label">{label}</div>
      <div className="stat-value" style={{ color }}>{(value || 0).toLocaleString()}</div>
      <div className="stat-sub">{sub}</div>
    </div>
  );
}
